import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { FinanceService } from '../lib/finance.service'

export const INVOICE_PAYMENT_METHODS = 'invoice-payment-methods'

type Props = {
  invoiceId?: string
}

export const useInvoicePaymentMethods = ({ invoiceId }: Props) => {
  return useQuery({
    queryKey: [INVOICE_PAYMENT_METHODS, invoiceId],
    queryFn: () => FinanceService.getInvoicePaymentMethods({ invoiceId }),
    placeholderData: keepPreviousData
  })
}
